import { action, computed, IReactionDisposer, makeObservable, reaction, toJS } from 'mobx';
import { JobFormManager } from '../job-form.manager';
import { JobCategory } from 'jobs/types';
import { JobCategoryGroupModel } from './job-category-group';
export class JobCategoriesGroupModel {
   readonly categoryModel: JobCategoryGroupModel;
   readonly categoryModel1: JobCategoryGroupModel;
   readonly categoryModel2: JobCategoryGroupModel;

   readonly disposers: IReactionDisposer[] = [];

   constructor(public readonly jobManager: JobFormManager) {
      makeObservable(this, {
         categories: computed,
         onAdd: action.bound,
      });
      this.categoryModel = new JobCategoryGroupModel();
      this.categoryModel1 = new JobCategoryGroupModel();
      this.categoryModel2 = new JobCategoryGroupModel();

      if(jobManager.MODE === 'CREATE') {
         this.categoryModel1.hide();
         this.categoryModel2.hide();
      }
      this._subscribe();
   }

   get attr() {
      return this.jobManager.jobAttributes.get();
   }

   get categories(): JobCategory[] {
      const jobAttr = this.jobManager.jobAttributes.get();
      if (jobAttr) {
         return jobAttr.categories;
      }
      return [];
   }

   onAdd(): void {
      const firstCm = [this.categoryModel1, this.categoryModel2].find((cm) => cm.hidden);
      firstCm?.show();
   }

   dispose(): void {
      this.disposers.forEach((d) => d());
   }

   public restoreValues(): void {
      const form = this.jobManager.form;

      if (this.attr) {
         this.categoryModel.onCategoryChange(form.controls['category'].value);
         this.categoryModel.restore(form.controls['subCategory'].value, this.attr.subcategories);

         const cat1 = form.controls['category_1'].value;
         const catSub1 = form.controls['subCategory_1'].value;

         if (cat1 && catSub1.length > 0) {
            this.categoryModel1.onCategoryChange(cat1);
            this.categoryModel1.restore(catSub1, this.attr.subcategories_2);
         } else {
            this.categoryModel1.hide();
         }

         const cat2 = form.controls['category_2'].value;
         const catSub2 = form.controls['subCategory_2'].value;
         
         if (cat2 && catSub2.length > 0) {
            this.categoryModel2.onCategoryChange(cat2);
            this.categoryModel2.restore(catSub2,this.attr.subcategories_3);
         } else {
            this.categoryModel2.hide();
         }
      }
   }

   private _subscribe(): void {
      const disposer = reaction(
         () => {
            return {
               catGroup: this.categoryModel.value,
               catGroup1: this.categoryModel1.value,
               catGroup2: this.categoryModel2.value,
            };
         },
         (ctx) => {
            this.jobManager.form.controls['category'].setValue(ctx.catGroup.cat);
            this.jobManager.form.controls['subCategory'].setValue(ctx.catGroup.subCat);
            this.jobManager.form.controls['category_1'].setValue(ctx.catGroup1.cat);
            this.jobManager.form.controls['subCategory_1'].setValue(ctx.catGroup1.subCat);
            this.jobManager.form.controls['category_2'].setValue(ctx.catGroup2.cat);
            this.jobManager.form.controls['subCategory_2'].setValue(ctx.catGroup2.subCat);
         }
      );
      this.disposers.push(disposer);
   }
}
